import React, { Component } from 'react';

//communication with external server 
import axios from 'axios';

//Bluetooth set-up
//import Bluetooth from 'node-web-bluetooth'; 

//necessary for ACE IDE
import AceEditor from 'react-ace';
import "ace-builds/src-noconflict/mode-python";
import "ace-builds/src-noconflict/theme-dracula";

//imported components 
import ColorPicker from '../components/ColorPicker';
import Button from '../components/Button';
import Charm from '../components/Matrix/Charm'
import DesignMatrix from '../components/Matrix/DesignMatrixWrapper';
import ColorButton from '../components/ColorButton';
import KeywordButton from '../components/KeywordButton'
import UploadButton from '../components/UploadButton'

import Switch from '@material-ui/core/Switch';
import Grid from '@material-ui/core/Grid';
import Fab from '@material-ui/core/Fab'

import ReactGA from 'react-ga';
import SaveButton from '../components/SaveButton';
import Python from '../data/Snakey.png'
import {ScrollingTextFrames} from '../data/Scrolling-text';

const PYTHON_KEYWORDS_PINK = ['for', 'if', 'elif', 'else', 'while', 'in', 'and', 'or', 'not', 'def', 'import', 'from']
const PYTHON_KEYWORDS_PURPLE = ['True', 'False']
const PYTHON_KEYWORDS_WHITE = ["m", "row", "col", "on", "off"]
const PYTHON_KEYWORDS_BLUE = ['range']
const PYTHON_KEYWORDS_COLORS = [["R", "rgb(255,0,0)"], ["G", "rgb(0,255,0)"], ["B", "rgb(0,0,255)"], ["A", "rgb(0,255,255)"], ["Y", "rgb(255,255,0)"], ["O", "rgb(255,165,0)"], ["M", "rgb(255,0,255)"], ["P", "rgb(148,0,211)"], ["W", "rgb(255,255,255)"]]
const PYTHON_KEYWORDS_SPECIALCHAR = ["[ ]", "( )", ":", ","]


export default class Create extends Component {
    constructor(props) {
        super(props);
        this.state = {
            writtenCode: (`${this.props.location.state}` === 'undefined' ? "" : `${this.props.location.state.projectCode}`),
            receivedJSON: "",
            designMatrixColors: [[0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0]],
            color: { r: 242, g: 170, b: 224 },
            errors: [],
            design_view: false,
            stored_colors: ["rgb(242,170,224)", "rgb(103, 212, 239)", "rgb(255, 244, 108)", "rgb(248, 163, 15)", "rgb(51, 225, 142)", "rgb(255, 0, 0)", "rgb(0, 255, 0)", "rgb(0, 0, 255)", "rgb(148, 0, 211)", "rgb(255, 0, 255)", "rgb(0,0,0)"],
            chosen_stored_color: 0,
            should_display_python_keywords: false,
            codeIDEheight: 85, //in vh,
            latestWrittenCoceHasNotBeenSuccessfullyRun: true,
            latesWrittenCodeHasNotBeenRun: true,
            pauseCode: false,
            projectTitle: (`${this.props.location.state}` === 'undefined' ? "" : `${this.props.location.state.privateTitle}`),
            openingTitle: (`${this.props.location.state}` === 'undefined' ? "" : `${this.props.location.state.privateTitle}`),
        }

    }


    handleProjectTitleChange = (event) => {
        this.setState({
            projectTitle: event.target.value
        })
    }

    handleEditorChange = (newValue) => {

        this.setState({
            writtenCode: newValue,
            latestWrittenCoceHasNotBeenSuccessfullyRun: true,
            latesWrittenCodeHasNotBeenRun: true
            
        })
    }

    fetchData = () => {
        axios.post(`https://imagilabs-webapp-test.herokuapp.com/code-interpreter`, { code: this.state.writtenCode })
            .then(response => {

                //if it's the first time displaying the error bar 
                if (this.state.errors.length === 0) {
                    this.setState({
                        codeIDEheight: this.state.codeIDEheight - 5, 
                        latesWrittenCodeHasNotBeenRun: false
                    })
                }

                if (response.data.errors[0].length >= 2) {
                    this.setState({
                        errors: response.data.errors[0][0] + ": " + response.data.errors[0][1],
                        receivedJSON: "",
                        latesWrittenCodeHasNotBeenRun: false,
                    })

                }

                else {
                    // console.log('response data output: ', response.data.output)
                    this.setState({
                        receivedJSON: response.data.output,
                        errors: "Success!",
                        latestWrittenCoceHasNotBeenSuccessfullyRun: false,
                        latesWrittenCodeHasNotBeenRun: false

                    })
                    if (response.data.output.scrolling_text.text !== null){
                        let text = response.data.output.scrolling_text.text;
                        let duration = response.data.output.scrolling_text.duration;
                        let loopCount = response.data.output.scrolling_text.loop_count;
                        let textColor = response.data.output.scrolling_text.text_color;
                        let backColor = response.data.output.scrolling_text.back_color;
                        let scrollingText = new ScrollingTextFrames(text, loopCount, duration, textColor, backColor);
                        let animation = scrollingText.init();
                        let animationObj = {animation : animation}
                        this.setState({
                            receivedJSON : animationObj
                        })
                    }

                }


            })
            .catch(error => {
                console.log("ERROR: ", error)
            })



    }


    onColorChangeInWheelPicker = color => {

        ReactGA.event({
            category: "User",
            action: "Used ColorWheel"
        })

        let newStoredColors = this.state.stored_colors
        newStoredColors[this.state.chosen_stored_color] = color.rgbString

        this.setState({
            color: color.rgb,
            stored_colors: newStoredColors


        });

    };

    handleToggleChange = () => {
        ReactGA.event({
            category: "User",
            action: "Toggle between design and code"
        })

        this.setState({
            design_view: !this.state.design_view
        });
    }

    handlePixelClicked = (row, col) => {
        //changing the preview colors 
        ReactGA.event({
            category: "User",
            action: "Clicked on a pixel in design matrix"
        })

        let NewMatrixColors = this.state.designMatrixColors
        NewMatrixColors[row * 8 + col] = [this.state.color.r, this.state.color.g, this.state.color.b]

        this.setState({
            designMatrixColors: NewMatrixColors,

        })


    }

    clearDesignMatrix = () => {
        ReactGA.event({
            category: "User",
            action: "Cleared design matrix"
        })
        this.setState({
            designMatrixColors: [[0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0]]

        })
    }

    handleClickOnStoredColor = (id) => {

        if (id !== (this.state.stored_colors.length - 1)) {


            let color = this.state.stored_colors[id].slice(4, -1).split(",")

            this.setState({
                chosen_stored_color: id,
                color: { r: color[0], g: color[1], b: color[2] }
            })
        }
        else {
            this.setState({
                chosen_stored_color: id,
                color: { r: 0, g: 0, b: 0 }
            })


        }

    }

    dispalyStoredColors = () => {

        return (
            <div style={{ justifyContent: "space-evenly", display: "flex", flexWrap: "wrap", marginBottom: "4%" }}>

                {this.state.stored_colors.slice(0, 6).map((color, index) =>
                    <ColorButton current_selection={this.state.chosen_stored_color} key={index} onClick={this.handleClickOnStoredColor} button_id={index} color={color} />)}
                <div style={{ width: "100%", justifyContent: "space-evenly", display: "flex", marginLeft: "20px", marginRight: "20px" }}>

                    {this.state.stored_colors.slice(6).map((color, index) =>

                        <ColorButton current_selection={this.state.chosen_stored_color} key={index} onClick={this.handleClickOnStoredColor} button_id={index + 6} color={color} />)}
                </div>
            </div>

        )
    }

    handleClickOnHelp = () => {
        ReactGA.event({
            category: "User",
            action: "Clicked on the Question Mark"
        })
        this.setState({
            should_display_python_keywords: !this.state.should_display_python_keywords,
            codeIDEheight: (!this.state.should_display_python_keywords ? this.state.codeIDEheight - 5 : this.state.codeIDEheight + 5)
        })


    }

    handleClicOnPythonKeyword = (id) => {
        ReactGA.event({
            category: "User",
            action: "Click on a python Keyword"
        })
        this.setState({
            writtenCode: this.state.writtenCode + " " + id
        })
    }



    displayPythonKeywords = () => {
        if (this.state.should_display_python_keywords) {

            return (
                <div style={{ display: "flex", backgroundColor: "#282a36", height: "auto", minHeight: "5vh" }} >
                    <div style={{ padding: "0.5%", width: "95%" }}>
                        {PYTHON_KEYWORDS_PINK.map((keyword) =>
                            <KeywordButton key={keyword}
                                color=" #ff79c6"
                                borderColor=" #ff79c6"
                                button_id={keyword}
                                onClick={this.handleClicOnPythonKeyword}>{keyword}</KeywordButton>)}
                        {PYTHON_KEYWORDS_PURPLE.map((keyword) =>
                            <KeywordButton key={keyword}
                                color="#bd93f9"
                                borderColor="#bd93f9"
                                button_id={keyword}
                                onClick={this.handleClicOnPythonKeyword}>{keyword}</KeywordButton>)}
                        {PYTHON_KEYWORDS_BLUE.map((keyword) =>
                            <KeywordButton key={keyword}
                                color="#8be9fd"
                                borderColor="#8be9fd"
                                button_id={keyword}
                                onClick={this.handleClicOnPythonKeyword}>{keyword}</KeywordButton>)}
                        {PYTHON_KEYWORDS_WHITE.map((keyword) =>
                            <KeywordButton key={keyword}
                                color="white"
                                borderColor="white"
                                button_id={keyword}
                                onClick={this.handleClicOnPythonKeyword}>{keyword}</KeywordButton>)}

                        <div style={{ height: "5px" }}></div>

                        {PYTHON_KEYWORDS_SPECIALCHAR.map((keyword) =>
                            <KeywordButton key={keyword}
                                color="white"
                                borderColor="white"
                                button_id={keyword}
                                onClick={this.handleClicOnPythonKeyword}>{keyword}</KeywordButton>)}

                        {PYTHON_KEYWORDS_COLORS.map((keyword) =>
                            <KeywordButton key={keyword[0]}
                                color="white"
                                borderColor={keyword[1]}
                                button_id={keyword[0]}
                                onClick={this.handleClicOnPythonKeyword}>{keyword[0]}</KeywordButton>)}


                    </div>
                </div>

            )
        }

    }

    displayError = () => {

        let red = "#FF857E"
        let green = "#33E18E"

        if (this.state.errors.length > 0) {
            return (
                <p style={{ display: "flex", backgroundColor: "black", marginTop: "0", marginBottom: "0", textAlign: "left", paddingLeft: "1%", paddingTop: "1%", paddingBottom: "1%", color: (this.state.errors === "Success!" ? green : red) }}>{this.state.errors}</p>
            )
        }

    }


    handleRunCode = () => {
        ReactGA.event({
            category: "User",
            action: "Click on RUN MY CODE in code view"
        })
        this.fetchData()
        if(this.state.pauseCode) {
                this.setState({
                pauseCode: !this.state.pauseCode
            })
        }
		this.setState({
            design_view: false
        });
    }

    handlePauseRunningCode = () => {
        this.setState({
            pauseCode: !this.state.pauseCode
        })

    }

    copyRGBvalue = async () => {
        await navigator.clipboard.writeText(`(${this.state.color.r},${this.state.color.g},${this.state.color.b})`)
    }

    viewPicker = () => {
        if (!this.state.design_view) {
            return (
                <div style={{ textAlign: "center" }}>
                    <Charm data={this.state.receivedJSON === "" ? "" : this.state.receivedJSON.animation.frames} loopCount={this.state.receivedJSON === "" ? "" : this.state.receivedJSON.animation.loop_count} pauseCode={this.state.pauseCode} />
                    <button disabled={!this.state.latesWrittenCodeHasNotBeenRun} style={{ height: '50px', width: "90%", marginTop: '10px', marginBottom: '10px' }} onClick={this.handleRunCode}>Run my code</button>
                    <button disabled={!this.state.latesWrittenCodeHasNotBeenRun && this.state.receivedJSON ? this.state.receivedJSON.animation.frames.length < 2 : true} style={{ height: '50px', width: "90%", marginTop: '10px', marginBottom: '10px' }} onClick={this.handlePauseRunningCode}>{this.state.pauseCode || this.state.latesWrittenCodeHasNotBeenRun? 'Start animation' : 'Stop animation'}</button>
                    <SaveButton projectCode={this.state.writtenCode} openingTitle={this.state.openingTitle} projectTitle={this.state.projectTitle}>Save project</SaveButton>
                    <UploadButton activity_state={this.state.latestWrittenCoceHasNotBeenSuccessfullyRun} data={this.state.receivedJSON} >Upload to imagiCharm</UploadButton>
                </div>


            )

        }

        else {
            return (
                <div style={{ textAlign: "center" }}>
                    <DesignMatrix data={this.state.designMatrixColors} mouseClick={this.handlePixelClicked} />

                    <button disabled={!this.state.latesWrittenCodeHasNotBeenRun} style={{ height: '50px', width: "90%", marginTop: '10px', marginBottom: '10px' }} onClick={this.handleRunCode}>Run my code</button>


                    {this.dispalyStoredColors()}

                    <ColorPicker
                        color={this.state.color}
                        onColorChange={this.onColorChangeInWheelPicker}
                        width='200'
                        display='inline-block'
                        layoutDirection="horizontal"
                        margin="3"
                        padding='3'
                        handleRadius="10"
                    />

                    <p style={{ color: 'white' }}>R: {this.state.color.r} G:{this.state.color.g} B: {this.state.color.b} <span><button onClick={this.copyRGBvalue}>Copy!</button></span> </p>

                    <Button onClick={this.clearDesignMatrix}>Clear the matrix</Button>

                </div>
            )
        }

    }



    render() {
        return (


            <div style={{ display: "flex", marginLeft: '1%', textAlign: "center" }}>

                <div style={{ display: "block", width: "20%", minWidth: "354px", marginRight: "1%" }}>
                    <div style={{ display: "flex", textAlign: "center", flexDirection: "column" }}>

                        <Grid container alignItems="center" justify="center" spacing={1}>

                            <Grid item><p style={{ color: 'white' }}>Code</p></Grid>
                            <Grid item>
                                <Switch checked={this.state.design_view} onChange={this.handleToggleChange} color="default" name="checkedA" />
                            </Grid>
                            <Grid item><p style={{ color: 'white' }}>Design</p></Grid>

                        </Grid>

                        {this.viewPicker()}

                    </div >
                </div>






                <div style={{ display: "flex", height: "100%", flexDirection: "column", width: "78%" }}>

                    <input onChange={this.handleProjectTitleChange} style={{ marginBottom: "1%", width: "auto", height: "25px", maxWidth: "300px" }} placeholder={"Give your project a name here"} value={this.state.projectTitle}></input>

                    <AceEditor
                        value={this.state.writtenCode} //otherwise the re-render will clear the editor
                        height={this.state.codeIDEheight.toString() + "vh"}
                        //height = "90vh"
                        width="100%"
                        mode="python"
                        theme='dracula'
                        onChange={this.handleEditorChange}
                        fontSize="22px" />


                    {this.displayPythonKeywords()}

                    {this.displayError()}

                    <Fab onClick={this.handleClickOnHelp} style={{ margin: 0, top: 'auto', right: 23, bottom: 15, left: 'auto', position: 'fixed', backgroundColor: "#F2AAE0" }}><img alt="python" src={Python}></img></Fab>
                </div>
            </div>

        )

    }
}


